import { createScenario } from '@funtech-int/rival';
import { lazy } from '@funtech-int/rival-react';

import { RouteSkeleton } from '@/shared/components/PageSpinner/PageSpinner';

import { personalRoute, historyRoute } from './routes';

const scenario = createScenario((ctx) => {
    ctx.addRoute({
        route: personalRoute,
        meta: {
            plusPaymentPage: 'MyPage',
            page: 'personal',
        },
        component: lazy(() => import('./components/PersonalPage/PersonalPage')),
        fallback: RouteSkeleton,
    });

    ctx.addRoute({
        route: historyRoute,
        meta: {
            plusPaymentPage: 'WatchingHistoryScreen',
            page: 'history',
        },
        component: lazy(() => import('./components/WatchingHistoryPage/WatchingHistoryPage')),
        fallback: RouteSkeleton,
    });
});

export * from './routes';

export default scenario;
